import React from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomDropdown from "../../../../Core/Components/CustomDropdown";
import useCargoItems from "../useCargoItems";
import {
  updateActivityForStop,
  updateTrips,
} from "../../../../Redux/Slices/trips.slice";
import ChevronIcon from "../../../../Common/Svgs/ChevronIcon";

const CargoSelector = ({
  data,
  totalLength,
  open,
  setOpen,
  activity,
  setActivity,
  cargo,
  setCargo,
}) => {
  const dispatch = useDispatch();

  const { stops, toastMessage, validationForSteps } = useSelector(
    (state) => state.trips,
  );

  const hubBasedCargoItems = useCargoItems();

  const disabled = data.id === 1 || data.id === totalLength;

  const renderBorderColorForCargo = () => {
    if (data.id !== 1 && data.id !== totalLength) {
      if (open) return "border border-primary";

      if (
        validationForSteps.step1.activity.includes(data.id) &&
        cargo.key === 1
      )
        return "border border-alert-red";
    }

    return "border border-light-grey";
  };

  const handleActivityAndCargoSelection = (e, id) => {
    setCargo(e);

    const newId = stops[id - 1].activities.length + 1;

    if (activity.key !== 1) {
      const newActivity = {
        id: newId,
        activity: activity.value,
        activityId: activity.key,
        cargo: e.value,
        cargoId: e.key,
      };

      const existingStop = stops.find((st) => st.id === id);

      if (existingStop) {
        const existingActivity = existingStop.activities.find(
          (act) =>
            act.activity === newActivity.activity &&
            act.cargo === newActivity.cargo,
        );

        const sameCargoActivity = existingStop.activities.find(
          (act) => act.cargo === newActivity.cargo,
        );

        if (existingActivity) {
          // Activity already exists for the stop
          dispatch(
            updateTrips({
              key: "toastMessage",
              value: {
                ...toastMessage,
                visible: true,
                type: "sameActivity",
                id,
              },
            }),
          );
        } else if (sameCargoActivity) {
          // Multiple activities for same exists for the stop
          dispatch(
            updateTrips({
              key: "toastMessage",
              value: {
                ...toastMessage,
                visible: true,
                type: "sameCargoActivity",
                id,
              },
            }),
          );
        } else {
          // Add the new activity to the existing stop
          dispatch(
            updateActivityForStop({
              newActivity,
              itemId: id,
            }),
          );

          dispatch(
            updateTrips({
              key: "toastMessage",
              value: {
                ...toastMessage,
                visible: true,
                type: "activityCreated",
                id,
              },
            }),
          );
          dispatch(
            updateTrips({
              key: "validationForSteps",
              value: {
                ...validationForSteps,
                step1: {
                  ...validationForSteps.step1,
                  activity: validationForSteps.step1.activity.filter(
                    (act) => act !== id,
                  ),
                },
              },
            }),
          );
          setActivity({ key: 1 });
          setCargo({ key: 1 });
        }
      }
    }
  };

  return (
    <CustomDropdown
      trigger={["click"]}
      // items={cargoItems}
      customHeight="max-h-[200px]"
      items={hubBasedCargoItems}
      disabled={disabled}
      dropDownOpen={open}
      onOpenChange={(flag) => setOpen(flag)}
      handleClick={(e) => {
        handleActivityAndCargoSelection(e, data.id);
      }}
    >
      <div>
        <p className="text-xs font-normal capitalize font-aileron text-dark-gray">
          Commodity
        </p>
        <div
          className={`mt-1 w-full rounded-md border py-2 px-3.5 h-9.5 flex items-center justify-between cursor-pointer
                        ${renderBorderColorForCargo()}
                        ${disabled ? "bg-new-gray" : ""} `}
        >
          <div
            className={`text-xs font-semibold text-black capitalize font-aileron ${
              disabled ? "text-dark-grey" : "text-black"
            }`}
          >
            {disabled ? (
              <p>None</p>
            ) : (
              <p className="text-xs font-semibold text-black capitalize font-aileron">
                {cargo.key === 1 ? "Select A Commodity" : `${cargo.value}`}
              </p>
            )}
          </div>

          <ChevronIcon
            className={`w-5 h-5 transform transition-all duration-200 ${
              disabled ? "stroke-light-grey" : "stroke-dark-gray"
            }
            ${open ? "-rotate-90" : "rotate-90"}`}
          />
        </div>
      </div>
    </CustomDropdown>
  );
};

export default CargoSelector;
